import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import Reveal from '../Reveal/Reveal'
import track from '../../lib/track'
import './EngagementModels.scss'

/**
 * The three ways a client can buy from us. Buyers who reach the bottom of a
 * services page usually have one question left — "how would this actually
 * work commercially?" — and answering it here beats making them ask.
 * No prices: those are fixed in writing after the scoping call.
 */
const EngagementModels = ({ from = 'unknown' }) => {
  const { translations: t } = useContext(LanguageContext)
  const navigate = useNavigate()

  const models = [
    { id: 1, num: '01' },
    { id: 2, num: '02' },
    { id: 3, num: '03' },
  ]

  const onCall = () => {
    track('call_click', { from: `engagement-${from}` })
    navigate('/contact-us#book')
  }
  const onEstimate = () => {
    track('estimator_click', { from: `engagement-${from}` })
    navigate('/estimate')
  }

  return (
    <section className='eng'>
      <Reveal>
        <p className='eng-kicker'>{t.engKicker}</p>
        <h2 className='eng-title'>{t.engTitle}</h2>
      </Reveal>
      <div className='eng-grid'>
        {models.map((m, i) => (
          <Reveal key={m.id} delay={i * 0.08} className='eng-card'>
            <span className='eng-num'>{m.num}</span>
            <h3 className='eng-card-title'>{t[`eng${m.id}Title`]}</h3>
            <p className='eng-best'>{t[`eng${m.id}Best`]}</p>
            <p className='eng-text'>{t[`eng${m.id}Text`]}</p>
            <p className='eng-start'>{t[`eng${m.id}Start`]}</p>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className='eng-actions'>
          <button type='button' className='eng-btn' onClick={onCall}>
            {t.engCta} <span aria-hidden='true'>→</span>
          </button>
          <button type='button' className='eng-btn eng-btn-ghost' onClick={onEstimate}>
            {t.barEstimate}
          </button>
        </div>
      </Reveal>
    </section>
  )
}

export default EngagementModels
